export const topicColor = {
  positive: '#D3F8DF',
  negative: '#FFDDE1',
  neutral: '#FFEFD5',
  undefined: '#e8e8e8',
}

// Brand chart series palette (PET-2043). Mirrors the `--ss-*` theme tokens in
// packages/semantic-ui-theme/.../site.variables. ApexCharts needs literal hex
// (it cannot resolve `var(--ss-*)`), so the values are duplicated here.
// 10 non-neutral brand hues (black/grey/white/brown excluded), each as [light, solid].
const SS_HUE = {
  blue: ['#66B2FF', '#007EFF'],
  purple: ['#BE9AF5', '#804DC8'],
  violet: ['#DC73FF', '#A333C8'],
  pink: ['#FF8EDF', '#E03997'],
  red: ['#FF798B', '#D00218'],
  orange: ['#FF851B', '#F2711C'],
  yellow: ['#FFC86D', '#F5A623'],
  olive: ['#D9E778', '#B5CC18'],
  green: ['#7AD69A', '#43BE64'],
  teal: ['#83F5FF', '#00C7E6'],
}

// Three hue orders for categorical (non-sentiment) charts. Same 10 hues + the
// same light→solid fallback; only the starting rotation differs. Rotated per
// widget (see getRotatingCategoricalColors) so a dashboard isn't monochrome.
// Sentiment charts do NOT use these — they keep OPINION_SCALE_COLORS.
const CATEGORICAL_HUE_ORDERS = [
  ['blue', 'purple', 'violet', 'pink', 'red', 'orange', 'yellow', 'olive', 'green', 'teal'],
  ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'purple', 'violet', 'pink'],
  ['green', 'olive', 'yellow', 'orange', 'red', 'pink', 'violet', 'purple', 'blue', 'teal'],
]

// Each palette: 10 light shades first, then their 10 solids as the fallback tier.
const buildPalette = (hueOrder) => [
  ...hueOrder.map((hue) => SS_HUE[hue][0]),
  ...hueOrder.map((hue) => SS_HUE[hue][1]),
]

export const BRAND_CHART_PALETTES = CATEGORICAL_HUE_ORDERS.map(buildPalette)

// Default order (Variant 1) — for charts with no dashboard position.
export const BRAND_CHART_SERIES_COLORS = BRAND_CHART_PALETTES[0]

// Rotate the categorical palette by the widget's saved 0-based position
// (`widget.order`) so neighbouring dashboard widgets don't lead with the same
// hue: widget 0 → V1, 1 → V2, 2 → V3, 3 → V1, … Falls back to Variant 1 when
// order is missing/invalid.
export const getRotatingCategoricalColors = (order = 0) => {
  const count = BRAND_CHART_PALETTES.length
  const index = ((Math.trunc(order) % count) + count) % count
  return BRAND_CHART_PALETTES[Number.isNaN(index) ? 0 : index]
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/shared/constants/color.js